import type { SupportedRepubName } from '@cx-web/domain-types';

import { type AuthProvider, authProviders } from './auth-provider';

export type TrackingConfig = {
  authProvider: AuthProvider;
  /** When true, fingerprint/nirvana client scripts are not injected into <head>. */
  skipFingerprintScripts?: boolean;
  /** When true, GTM loading is gated behind user consent (e.g., privacyOK). Default behavior loads GTM immediately. */
  usesConsentGatedGTM?: boolean;
  /**
   * When true, the repub loads the RCS/Gazzetta Tealium tag manager (`utag.sync.js` in <head> +
   * `utag.js` in <body>). The two halves must stay in lockstep — the sync shim is a prelude to the
   * main tag — so both call sites read this single flag rather than testing the repub name.
   */
  usesTealium?: boolean;
};

export const TRACKING_CONFIGS = {
  WS: {
    authProvider: authProviders.WHOSCORED,
  },
  OC: {
    authProvider: authProviders.ODDSCHECKER,
  },
  US: {
    authProvider: authProviders.ODDSCHECKER,
  },
  GZ: {
    authProvider: authProviders.ODDSCHECKER,
    usesConsentGatedGTM: true,
    usesTealium: true,
    skipFingerprintScripts: true,
  },
} satisfies Record<SupportedRepubName, TrackingConfig>;
